import { StatusCodes } from "http-status-codes";
import { throttle } from "lodash";
import React, { useState } from "react";

import { CircularProgress, InputAdornment, TextField, TextFieldProps } from "@mui/material";

import { usePartnerAxios } from "../../common/partner-axios";

// type TestKitResponse = {
//   purchaseId: number;
//   activationDateUtc: string;
// };

type TestKitCodeTextFieldProps = TextFieldProps & { onValidate: (statusCode: StatusCodes, resp:"") => void };

export const TestKitCodeTextField = (props: TestKitCodeTextFieldProps) => {
  const { onValidate, ...textFieldProps } = props;

  const partnerAxios = usePartnerAxios();
  const [isChecking, setIsChecking] = useState(false);
  console.log(isChecking);

  const validateTestKit = throttle(async (testKitCode: string) => {
    if (!testKitCode) {
      return;
    }

    try {
      setIsChecking(true);
      await partnerAxios
  .get(`testkits/code|${encodeURIComponent(testKitCode)}`)
  .then(function (response) {
    console.log("Response",response);
    onValidate(StatusCodes.OK,response.data.sku);
  });
     // await partnerAxios.get<TestKitResponse>(`testkits/code|${encodeURIComponent(testKitCode)}`);
      console.log("TestKitResponse",encodeURIComponent(testKitCode))
      
    } catch (error: any) {
      onValidate(error.response?.status ?? StatusCodes.INTERNAL_SERVER_ERROR,"");
    } finally {
      setIsChecking(false);
    }
  }, 200);

  const handleTestKitCodeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    validateTestKit(e.target.value);
  };

  return (
    <>
      <TextField
        {...textFieldProps}
        onInput={handleTestKitCodeInput}
        InputProps={
          isChecking
            ? {
                style: {
                  padding: 0,
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <CircularProgress sx={{ p: 1 }} />
                  </InputAdornment>
                ),
              }
            : undefined
        }
      />
    </>
  );
};
